import styled from "@emotion/styled"
import { wv_willfade } from "./../styles"
import { bold, light, body50, headline30 } from "css/text"
import getMediaQuery, { media } from "css/breakpoints"

export const Main = styled.section`
  display: none;
  ${wv_willfade}
  &.wv_reveal {
    transition-delay: 300ms;
  }
  position: relative;
  z-index: 1;
  padding: 0 var(--outer-margin);
  ${light}
  min-height: 4lh;

  .wvIncard & {
    padding: 0 var(--gv-padding-inline);
    min-height: 2lh;
    padding-block: 0;
    display: block;
  }

  .wv_reveal & {
    display: block;
  }

  & > h2 {
    font-weight: 400;
  }

  .wv_ref & {
    & > h2 {
      margin-block-start: 1.25rem;
    }
  }

  ${getMediaQuery("xl")} {
    .wv_ref & {
      & > h2 {
        display: block;
        margin-block-start: 0rem;
      }
    }
    & > h2 {
      display: none;
      font-size: inherit;
      min-height: unset;
      ${headline30}
      margin-block-end: 1.8rem;
    }
    min-height: 2lh;
  }

  & > p {
    font-size: clamp(0.875rem, 0.8125rem + 0.1563vw, 1rem); // 14px > 16px
    &:nth-of-type(1) {
      ${wv_willfade}
    }
  }

  & > div {
    ${wv_willfade}
    &.wv_reveal {
      visibility: inherit;
    }
    min-height: 3ex;
    & > p {
      align-items: center;
      font-size: clamp(0.875rem, 0.8125rem + 0.1563vw, 1rem); // 14px > 16px
      & button {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          padding: 1rem;
          box-sizing: border-box;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
        }
      }
      .wvIncard & {
        column-gap: 0;
        & button {
          transform: scale(.9);

          ${getMediaQuery("l")} {
            transform: scale(1);
          }
        }
      }
    }
  }
`

export const WLoader = styled.span`
  ${wv_willfade}
  &.wv_reveal {
    transition-delay: 400ms;
  }
  position: absolute;
  left: var(--outer-margin);
`
